import React from "react";
import "./styles.css";

import Logo from "../../assets/img/OMEX_white.png";
import AuthBackgroundVideo from "../../assets/img/abstract_2560_1440.mp4";

interface AuthShellProps {
  children: React.ReactNode;
  eyebrow?: string;
  title: string;
  subtitle?: string;
  logoAlt?: string;
  onLogoClick?: () => void;
  variant?: "login" | "wide";
}

export const AuthShell = ({
  children,
  eyebrow,
  title,
  subtitle,
  logoAlt = "Logo da Omex Capital",
  onLogoClick,
  variant = "login",
}: AuthShellProps) => {
  return (
    <main className={`auth-shell auth-shell-${variant}`}>
      <video className="auth-shell-video" autoPlay muted loop playsInline aria-hidden="true">
        <source src={AuthBackgroundVideo} type="video/mp4" />
      </video>
      <div className="auth-shell-scrim" aria-hidden="true" />

      <section className="auth-shell-content">
        <div className="auth-brand-panel">
          <button
            className="auth-logo-button"
            type="button"
            onClick={onLogoClick}
            aria-label="Ir para o login"
          >
            <img src={Logo} alt={logoAlt} className="auth-logo" />
          </button>

          {eyebrow && <p className="auth-eyebrow">{eyebrow}</p>}
          <h1>{title}</h1>
          {subtitle && <p className="auth-subtitle">{subtitle}</p>}

          <div className="auth-signal-strip" aria-hidden="true">
            <span />
            <span />
            <span />
          </div>
        </div>

        <div className="auth-form-panel">{children}</div>
      </section>
    </main>
  );
};
